/*
 * Shared product reviews: progressive enhancement only. Every review is already
 * rendered by Liquid; this adds "Show more" (revealing the rest of page 1, then
 * fetching pages 2..n from /pages/be-reviews-page/<handle>-p<n>, which Shopify
 * serves from the be_garment_reviews_page metaobjects), the photo lightbox and the
 * carousel arrows.
 */
(function () {
  function initWidget(root) {
    var pageSize = parseInt(root.getAttribute('data-be-reviews-page-size'), 10) || 5;
    var handle = root.getAttribute('data-be-reviews-handle') || '';
    var pageCount = parseInt(root.getAttribute('data-be-reviews-page-count'), 10) || 1;
    var list = root.querySelector('[data-be-reviews-list]');
    var more = root.querySelector('[data-be-reviews-show-more]');
    var nextPage = 2;
    var loading = false;

    function revealNext() {
      var hidden = root.querySelectorAll('[data-be-review][hidden]');
      for (var i = 0; i < hidden.length && i < pageSize; i++) hidden[i].removeAttribute('hidden');
      return Math.min(hidden.length, pageSize);
    }
    function updateMore() {
      if (!more) return;
      var exhausted = !root.querySelector('[data-be-review][hidden]') && nextPage > pageCount;
      if (exhausted) more.parentNode.removeChild(more);
    }
    // Pages 2..pageCount are Shopify-hosted metaobject pages; the storefront never calls the ERP.
    function loadNextPage() {
      var url = '/pages/be-reviews-page/' + handle + '-p' + nextPage;
      loading = true;
      more.setAttribute('aria-busy', 'true');
      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Review page ' + nextPage + ' failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-be-review]');
          for (var i = 0; i < cards.length; i++) {
            var card = document.importNode(cards[i], true);
            card.setAttribute('hidden', '');
            list.appendChild(card);
          }
          nextPage += 1;
        })
        .catch(function (error) {
          if (window.console) console.warn(error);
          nextPage = pageCount + 1;
        })
        .then(function () {
          loading = false;
          more.removeAttribute('aria-busy');
        });
    }
    if (more && list) {
      more.addEventListener('click', function () {
        if (loading) return;
        if (revealNext() > 0) return updateMore();
        if (nextPage > pageCount || !handle) return updateMore();
        loadNextPage().then(function () {
          revealNext();
          updateMore();
        });
      });
    }

    var lightbox = root.querySelector('[data-be-reviews-lightbox]');
    if (!lightbox) return;
    var image = lightbox.querySelector('img');
    var closeButton = lightbox.querySelector('[data-be-reviews-lightbox-close]');
    var opener = null;

    function close() {
      lightbox.setAttribute('hidden', '');
      image.setAttribute('src', '');
      document.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }
    function onKey(event) {
      if (event.key === 'Escape') close();
    }
    root.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-be-reviews-photo]') : null;
      if (!target || !root.contains(target)) return;
      opener = target;
      image.setAttribute('src', target.getAttribute('data-src'));
      lightbox.removeAttribute('hidden');
      document.addEventListener('keydown', onKey);
      if (closeButton) closeButton.focus();
    });
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target === closeButton) close();
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-be-reviews-carousel-track]');
    if (!track) return;
    function step(direction) {
      var slide = track.querySelector('li');
      var width = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: direction * width, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-be-reviews-carousel-prev]');
    var next = root.querySelector('[data-be-reviews-carousel-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function init() {
    var widgets = document.querySelectorAll('[data-be-reviews]');
    for (var i = 0; i < widgets.length; i++) initWidget(widgets[i]);
    var carousels = document.querySelectorAll('[data-be-reviews-carousel]');
    for (var j = 0; j < carousels.length; j++) initCarousel(carousels[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
